import React, { useState, useEffect } from 'react';
import logoIcon from '../../assets/images/logo-icon.svg';
import whiteLogoIcon from '../../assets/images/white-logo-icon.svg'
import burgerMenuIcon from '../../assets/images/burger-menu-icon.svg';
import { Box, Button, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import useUserStore from '../../store/useUserStore';
import instagramLightIcon from '../../assets/images/instagram-light.svg';
import telegramLightIcon from '../../assets/images/telegram-light.svg';
import linkedinLightIcon from '../../assets/images/linkedin-light.svg';

export default function Header({ onScrollTo, activeKey }) {
  const windowInnerWidth = useUserStore((state) => state.windowInnerWidth);
  const setWindowInnerWidth = useUserStore((state) => state.setWindowInnerWidth);
  const [menuOpen, setMenuOpen] = useState(false);

  const [activeItem, setActiveItem] = useState('header');

  useEffect(() => {
    if (activeKey) setActiveItem(activeKey);
  }, [activeKey]);

  useEffect(() => {
    const handleResize = () => setWindowInnerWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [menuOpen]);

  const mobileMenuWidth = 430;

  const mobileMenuStyle = {
    position: 'fixed',
    top: 0,
    right: 0,
    height: '100dvh',
    width: `${mobileMenuWidth}px`,
    maxWidth: '100vw',
    backgroundColor: "rgba(130, 139, 159, 1)",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: '30px',
    color: 'white',
    fontSize: '22px',
    fontWeight: 600,
    transition: 'transform 0.3s ease-in-out',
    transform: menuOpen ? 'translateX(0)' : `translateX(${mobileMenuWidth}px)`,
    zIndex: 1500,
  };

  const handleNavClick = (key, fn) => {
    setActiveItem(key);
    fn();
  };

  const handleMobileNavClick = (key, fn) => {
    setActiveItem(key);
    fn();
    setMenuOpen(false);
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    opacity: menuOpen ? 1 : 0,
    pointerEvents: menuOpen ? 'auto' : 'none',
    transition: 'opacity 0.3s ease-in-out',
    zIndex: 1400,
  };

  const contactBtnStyle = {
    fontSize: '20px',
    width: '190px',
    height: '64px',
    borderRadius: '60px',
    textTransform: 'none',
    backgroundColor: 'rgba(11, 25, 62, 1)',
    color: 'rgba(250, 253, 255, 1)',
    fontWeight: 500,
    border: 'none',
    boxShadow: 'none'
  };

  return (
    <header
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: windowInnerWidth < 768 ? '0 20px' : '0 80px',
        height: windowInnerWidth < 1280 ? '88px' : '100px',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        backdropFilter: 'blur(20px)',
        position: 'fixed',
        zIndex: 100,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          maxWidth: '1280px',
        }}
      >
        <Box
          // onClick={onScrollTo.header}
          component="img"
          sx={{ cursor: 'pointer' }}
          src={logoIcon}
          alt="logo image"
        />
        { windowInnerWidth > 1250 ? (
          <>
            <ul
              style={{
                listStyle: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '20px',
                margin: 0,
                color: 'rgba(11, 25, 62, 1)',
                fontSize: '16px',
                cursor: 'pointer',
              }}
            >
              <li style={{ fontWeight: activeItem === 'header' ? 700 : 400 }} onClick={() => handleNavClick('header', onScrollTo.header)}>Головна</li>
              <li style={{ fontWeight: activeItem === 'services' ? 700 : 400 }} onClick={() => handleNavClick('services', onScrollTo.services)}>Послуги</li>
              <li style={{ fontWeight: activeItem === 'howWeWork' ? 700 : 400 }} onClick={() => handleNavClick('howWeWork', onScrollTo.howWeWork)}>Як працюємо</li>
              <li style={{ fontWeight: activeItem === 'whoWeWorkWith' ? 700 : 400 }} onClick={() => handleNavClick('whoWeWorkWith', onScrollTo.whoWeWorkWith)}>Клієнти</li>
              <li style={{ fontWeight: activeItem === 'whyUs' ? 700 : 400 }} onClick={() => handleNavClick('whyUs', onScrollTo.whyUs)}>Чому ми?</li>
              {/* <li style={{ fontWeight: activeItem === 'projects' ? 700 : 400 }} onClick={() => handleNavClick('projects', onScrollTo.projects)}>Проєкти</li> */}
              <li style={{ fontWeight: activeItem === 'questions' ? 700 : 400 }} onClick={() => handleNavClick('questions', onScrollTo.questions)}>FAQ</li>
              <li style={{ fontWeight: activeItem === 'feedbacks' ? 700 : 400 }} onClick={() => handleNavClick('feedbacks', onScrollTo.feedbacks)}>Відгуки</li>
            </ul>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <Button
                variant="contained"
                onClick={() => window.open('https://calendly.com/kostiantinople/30min?month=2025-09', '_blank')}
                sx={contactBtnStyle}
              >
                Написати нам
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Box
              component="img"
              src={burgerMenuIcon}
              loading="lazy"
              alt="Menu image"
              style={{ cursor: 'pointer', width: '30px', height: '30px' }}
              onClick={() => setMenuOpen(true)}
            />
            <div style={overlayStyle} onClick={() => setMenuOpen(false)} />
            <nav style={mobileMenuStyle}>
              <Box
                component="img"
                loading="lazy"
                src={whiteLogoIcon}
                alt="logo image"
                sx={{ position: 'absolute', top: '20px', left: '20px', maxWidth: '121px' }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                }}
              >
                <IconButton
                  onClick={() => setMenuOpen(false)}
                  sx={{ color: 'white', padding: 0 }}
                  aria-label="close menu"
                >
                  <CloseIcon sx={{ fontSize: '40px' }} />
                </IconButton>
              </Box>
              <ul
                style={{
                  listStyle: 'none',
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '20px',
                  margin: 0,
                  padding: 0,
                  fontSize: '24px',
                  fontWeight: 400,
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
              >
                <li style={{ fontWeight: activeItem === 'header' ? 700 : 400 }} onClick={() => handleMobileNavClick('header', onScrollTo.header)}>Головна</li>
                <li style={{ fontWeight: activeItem === 'services' ? 700 : 400 }} onClick={() => handleMobileNavClick('services', onScrollTo.services)}>Послуги</li>
                <li style={{ fontWeight: activeItem === 'howWeWork' ? 700 : 400 }} onClick={() => handleMobileNavClick('howWeWork', onScrollTo.howWeWork)}>Як працюємо</li>
                <li style={{ fontWeight: activeItem === 'whoWeWorkWith' ? 700 : 400 }} onClick={() => handleMobileNavClick('whoWeWorkWith', onScrollTo.whoWeWorkWith)}>Клієнти</li>
                <li style={{ fontWeight: activeItem === 'whyUs' ? 700 : 400 }} onClick={() => handleMobileNavClick('whyUs', onScrollTo.whyUs)}>Чому ми?</li>
                {/* <li style={{ fontWeight: activeItem === 'projects' ? 700 : 400 }} onClick={() => handleMobileNavClick('projects', onScrollTo.projects)}>Проєкти</li> */}
                <li style={{ fontWeight: activeItem === 'questions' ? 700 : 400 }} onClick={() => handleMobileNavClick('questions', onScrollTo.questions)}>FAQ</li>
                <li style={{ fontWeight: activeItem === 'feedbacks' ? 700 : 400 }} onClick={() => handleMobileNavClick('feedbacks', onScrollTo.feedbacks)}>Відгуки</li>
              </ul>
              <Box sx={{ mt: 'auto', pb: '20px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 400,
                    textAlign: "center",
                  }}
                >
                  Зв’язатися з нами
                </Typography>
                <Box sx={{ display: "flex", gap: "20px", mt: "20px" }}>
              <Box
                component={"img"}
                src={telegramLightIcon}
                alt="telegram icon"
                width={'40px'}
                sx={{ cursor: "pointer" }}
                onClick={() =>
                  window.open("https://t.me/legalist2442", "_blank") 
                }
              />
              <Box
                component={"img"}
                src={instagramLightIcon}
                alt="instagram icon"
                width={'40px'}
                sx={{ cursor: "pointer" }}
                onClick={() => window.open("https://www.instagram.com/kbelinskyi/", "_blank")}
              />
              <Box
                component={"img"}
                src={linkedinLightIcon}
                alt="linkedin icon"
                width={'40px'}
                sx={{ cursor: "pointer" }}
                onClick={() => window.open("https://www.linkedin.com/in/kostia-belinskiy-b138b7269/", "_blank")}
              />
                </Box>
              </Box>
            </nav>
          </>
        )}
      </Box>

    </header>
  );
}
